import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=73fed23e&scoped=true"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=73fed23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fed23e",
  null
  
)

export default component.exports